<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.name" placeholder="角色名" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item :v-if="true">
            <el-button type="primary" @click="showAddDialog">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="role" highlight-current-row style="width: 100%;">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="roleName" label="角色名"></el-table-column>
        <el-table-column prop="roleSign" label="角色编码"></el-table-column>
        <el-table-column prop="status" label="启用状态" :formatter="statusFommater"></el-table-column>
        <el-table-column prop="orgName" label="所属机构"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button  size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button v-if="scope.row.orgId!=0" type="danger" @click="delBook(scope.$index,scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
       <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!--维护界面-->
      <el-dialog :title="addFormTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" @close="dialogClose">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="角色名" >
            <el-input v-model="addForm.data.roleName" auto-complete="off" placeholder="角色名"></el-input>
          </el-form-item>
          <el-form-item label="角色编码" >
            <el-input v-model="addForm.data.roleSign" auto-complete="off" placeholder="角色编码"></el-input>
          </el-form-item>
          <el-form-item label="所属单位">
            <TreeSelect ref="treeSelect" 
                    :props="props"
                    :options="orgList"
                    :value="valueId"
                    :clearable="isClearable"
                    :accordion="isAccordion"
                    @getValue="getValue($event)"
                   >
            </TreeSelect>  
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.data.remark" :rows="2" placeholder="备注"></el-input>
          </el-form-item>
          <el-form-item label="启用状态">
            <el-select v-model="addForm.data.status" placeholder="启用状态">
               <el-option v-for="(item,index) in statusSelect" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限">
            <TreeGrid style="height:450px"
                :data="menuData" :checkbox="true" idField="id" treeField="name" ref="roleTreeGride">
              <GridColumn field="name" title="名称"></GridColumn>
              <GridColumn field="url" title="地址"></GridColumn>
              <GridColumn field="type" title="类型"></GridColumn>
            </TreeGrid>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addForm.submit">提交</el-button>
        </div>
      </el-dialog>

    </el-col>
  </el-row>
</template>
<script>
  import util from '../../common/util'
  import API from '../../api/api_role';
  import MENU_API from '../../api/api_menu';
  import TreeSelect from '@/components/selectTree/treeSelect.vue';

  export default {
    components: { TreeSelect },
    data() {
      return {
        isClearable:true,      // 可清空（可选）
        isAccordion:true,      // 可收起（可选）
        valueId:'',            // 初始ID（可选）
        props:{                // 配置项（必选）
          value: 'id',
          label: 'name',
          children: 'children',
          // disabled:true
        },

        filters: {
          name: ''
        },
        statusFommater: function(row,column){
          var text = '';
          switch (row.status){
            case 0 : text="禁用";break;
            case 1 : text="启用";break;
          }
          return text;
        },
        statusSelect:[
          {
            value: 0,
            label: '禁用'
          },
          {
            value: 1,
            label: '启用'
          }

        ],
        role: [],
        clearable:true,
        total: 0,
        page: 1,
        limit: 10,
        loading: false,
        //维护相关数据
        addFormVisible: false,//新增界面是否显示
        addFormTitle:'',
        addForm: {
          data:{
            roleName: '',
            remark: '',
            org:'',
          },
          submit:function(){

          }
        },
        //查询的机构数据
        orgList:[],
        //菜单临时数据
        menuData:[]
      }
    },
    methods: {
       getValue(value){
        let that =this;
        that.valueId = value;
        that.addForm.data.orgId=value;
       },
      //维护窗口关闭事件
      dialogClose:function(e){
        let that = this;
        that.menuData =[];
      },
      init:function(callback){
        let that =this;
        let params={};
        that.loading=true;
        API.init(params).then(function (result) {
          that.loading = false;
          if (result.code=="200" && result.data) {
            that.orgList=result.data.org;
            that.menuData =result.data.menu;
            if(callback) setTimeout(callback, 200);
          }
        }, 
        function (err) {
          that.loading = false;
          that.$message.error({showClose: true, message: err.toString(), duration: 2000});
        })
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
        });
      },
      //递归
      recursionMenu:function(menuData,menuids){
        console.log(menuData);
        menuData.forEach((item)=>{
          
          if(item.children && item.children.length>0){
            this.recursionMenu(item.children,menuids);
          }
          else{
            if(menuids.indexOf(item.id)>-1){
              //console.log(item);
              this.$refs.roleTreeGride.checkRow(item);
            }
          }
        })
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      //查询
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
      search() {
        let that = this;
        let params = {
          page: that.page,
          limit: that.limit,
          name: that.filters.name
        };
        API.findList(params).then(function (result) {
          that.loading = false;
          console.log(result);
          if (result.code=="200" && result.data) {
            if(result.data  && result.data.records)
            {
                that.total= result.data.total;
                that.role=result.data.records;
            }
          }
        }, function (err) {
          that.loading = false;
          that.$message.error({showClose: true, message: err.toString(), duration: 2000});
        }).catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
        });
      },
      //删除
      delBook: function (index, row) {
        let that = this;
        this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
          that.loading = true;
          API.remove(row.id).then(function (result) {
            that.loading = false;
            if (result && result.code === 200) {
              that.$message.success({showClose: true, message: '删除成功', duration: 1500});
              that.search();
            }else{
              that.$message.error({showClose: true, message: result.msg, duration: 1500});
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({showClose: true, message: err.toString(), duration: 2000});
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
          });
        }).catch(() => {
        });
      },
      //显示编辑界面
      showEditDialog: function (index, row) {
        let that = this;
         //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.treeSelect){
          that.$refs.treeSelect.clearHandle();
        }
        this.addFormVisible = true;
        this.addFormTitle='编辑';
        this.addForm = {
          data:{
            roleName: '',
            roleSign:'',
            remark: '',
            orgId:'',
            status:'',
          },
        };
        //查询详情
        that.loading=true;
        API.findById(row.id).then(function (result) {
            console.log(result);
              that.loading = false;
              if (result && result.code === 200) {
                that.addForm.data= result.data.role;
                if(that.addForm.data.orgId==0){
                
                  that.addForm.data.orgId="";
                }
                that.valueId=that.addForm.data.orgId;
                let menuIds = result.data.menu;
                //递归选择已经选择的菜单
                //加载数据
                that.init(function(){that.recursionMenu(that.menuData,menuIds)});
                //提交按钮
                that.addForm.submit=function(){
                  let params =that.addForm.data;
                  let selectMenuIds = that.$refs.roleTreeGride.getCheckedRows("checked");
                  let menuIds=[];
                  selectMenuIds.forEach(item => {
                    menuIds.push(item.id);
                  });

                  params.menuIds= menuIds;
                  console.log(params);
                  that.loading=true;
                  API.update(params).then(function (result) {
                      that.loading = false;
                      console.log(result);
                      if (result && result.code === 200) {
                         that.addFormVisible = false;
                          that.search();
                      } else {
                        that.$message.error({showClose: true, message: result.msg, duration: 2000});
                      }
                    }, function (err) {
                      that.loading = false;
                      that.$message.error({showClose: true, message: err.toString(), duration: 2000});
                    }).catch(function (error) {
                      that.loading = false;
                      console.log(error);
                      that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
                    });
                }
              } else {
                that.$message.error({showClose: true, message: result.msg, duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });
      },
      //添加
      showAddDialog: function () {
        let that = this;
         //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.treeSelect){
          that.$refs.treeSelect.clearHandle();
        }
        this.addFormVisible = true;
        this.addFormTitle='新增';
        this.addForm = {
          data:{
            roleName: '',
            roleSign:'',
            remark: '',
            status:'',
          },
        };
        //加载数据
        that.init();
        that.addForm.submit=function(){
          let params =that.addForm.data;
          let selectMenuIds = that.$refs.roleTreeGride.getCheckedRows("checked");

          let menuIds=[];
          selectMenuIds.forEach(item => {
            menuIds.push(item.id);
          });
          console.log(params);
          params.menuIds= menuIds;
          that.loading=true;
          API.add(params).then(function (result) {
              that.loading = false;
              console.log(result);
              if (result && result.code === 200) {
                that.addFormVisible = false;
                that.search();
              } else {
                that.$message.error({showClose: true, message: result.msg, duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });
        
        }
      },

      //批量删除
      batchDeleteBook: function () {
        let ids = this.sels.map(item => item.id).toString();
        let that = this;
        this.$confirm('确认删除选中记录吗？', '提示', {
          type: 'warning'
        }).then(() => {
          that.loading = true;
          API.removeBatch(ids).then(function (result) {
            that.loading = false;
            if (result && parseInt(result.errcode) === 0) {
              that.$message.success({showClose: true, message: '删除成功', duration: 1500});
              that.search();
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({showClose: true, message: err.toString(), duration: 2000});
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
          });
        }).catch(() => {

        });
      },
      //获取选中、半选中节点
      getMenuIds: function () {
        return this.$refs.menuAddTree.getCheckedKeys().concat(this.$refs.menuAddTree.getHalfCheckedKeys())
      },
      /**
       * (keys, leafOnly) 接收两个参数，1. 勾选节点的 key 的数组 2. boolean 类型的参数，若为 true 则仅设置叶子节点的选中状态，默认值为 false
       */
      setMenuIds: function (keys) {
        this.$refs.menuAddTree.setCheckedKeys(keys, true)
      }
    },
    mounted() {
      this.handleSearch()

    }
  }
</script>

<!--<style>-->
<!--.demo-table-expand label {-->
<!--font-weight: bold;-->
<!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// list.vue?4fea70c6